module.exports = __webpack_public_path__ + "static/media/demo.0eeab1d4.mp4";